<template>
  <div class="game_box">
    <div class="game_title">{{ $t("gameinfo.game.gameinfo") }}</div>
    <div class="xian"></div>
    <div class="loading_box" v-if="loading"><loading></loading></div>
    <div class="game" v-if="!loading">
      <div class="game_chunk">
        <div class="game_texts">
          <div class="game_chunk_title">
            {{ $t("gameinfo.game.experience") }}：
          </div>
          <div class="game_time">
            {{ $t("gameinfo.game.send") }}:{{
              Newdata(this.gameDeveloperVo.updateTime)
            }}
          </div>
        </div>
        <div class="game_chunk_btn_box">
          <div>
            <div class="game_btn_preview CU" @click="previewAPP">
              {{ $t("gameinfo.game.gamepreview") }}
            </div>
          </div>
        </div>
      </div>
      <div class="game_chunk">
        <div class="game_texts">
          <div class="game_chunk_title">
            {{ $t("gameinfo.game.review_version") }}：
          </div>
          <div class="game_time" v-if="reviewVersion">
            {{ this.reviewVersion }}
          </div>
          <div class="game_time" v-else>
            {{ $t("gameinfo.game.no_review") }}
          </div>
        </div>
        <div class="game_chunk_btn_box">
          <div class="game_chunk_btn">
            <div
              class="game_btn CU"
              v-if="userState != 2 || !gameDeveloperVo.playUrl"
            >
              {{ $t("gameinfo.game.send_review") }}
            </div>
            <div
              class="game_btn game_btn_active CU"
              @click="showModal"
              v-if="
                userState == 2 && reviewStatus != 0 && gameDeveloperVo.playUrl
              "
            >
              {{ $t("gameinfo.game.send_review") }}
            </div>
            <div
              class="game_btn CU game_btn_active"
              v-if="reviewStatus == 0"
              @click="Cancel"
            >
              {{ $t("gameinfo.game.cancel_review") }}
            </div>
            <div class="game_btn_preview CU" @click="ExaminePreview">
              {{ $t("gameinfo.game.gamepreview") }}
            </div>
          </div>
          <div
            class="init_text init_text_active"
            v-if="!gameDeveloperVo.playUrl || userState == 1"
          >
            {{ $t("gameinfo.game.text") }}：
            <router-link
              :to="{
                path: '/account_management/authentication',
                query: { appId: appId },
              }"
              class="CU"
              tag="span"
              style="margin-right: 15px"
              v-if="userState == 1"
            >
              {{ $t("gameinfo.game.identity") }}
            </router-link>
            <router-link
              :to="{
                path: '/gameinfo/material',
                query: { appId: appId, gameId: gameId },
              }"
              class="CU"
              tag="span"
              v-if="!gameDeveloperVo.playUrl"
            >
              {{ $t("gameinfo.game.game_material") }}
            </router-link>
            {{ $t("gameinfo.game.text2") }}
          </div>
          <div class="init_text" v-if="reviewStatus == 0">
            {{ $t("gameinfo.game.emailtext") }}
            <span class="CU" @click="copy(configs)"
              >{{ configs }}({{ $t("gameinfo.game.copy") }})</span
            >
          </div>
        </div>
      </div>

      <div class="game_chunk">
        <div class="game_texts">
          <div class="game_chunk_title">
            {{ $t("gameinfo.game.online_version") }}：
          </div>
          <div class="game_time" v-if="onlineVersion">
            {{ onlineVersion }}
          </div>
          <div class="game_time" v-else>
            {{ $t("gameinfo.game.no_review") }}
          </div>
        </div>
        <div class="game_chunk_btn_box">
          <div class="game_chunk_btn">
            <div
              class="game_btn CU game_btn_active"
              v-if="reviewStatus == 1"
              @click="Online"
            >
              {{ $t("gameinfo.game.publish") }}
            </div>
            <div class="game_btn CU" v-else>
              {{ $t("gameinfo.game.publish") }}
            </div>
          </div>
          <div class="init_text init_text_active" v-if="reviewStatus != 1">
            {{ $t("gameinfo.game.publish_text") }}
          </div>
          <div class="init_text init_text_active" v-if="reviewStatus == 1">
            {{ $t("gameinfo.game.publish_text1") }}
          </div>
        </div>
      </div>

      <a-modal
        :title="$t('gameinfo.game.version')"
        :visible="visible"
        :okText="$t('gameinfo.game.ok')"
        :cancelText="$t('gameinfo.game.cancel')"
        @ok="SubmitAudit"
        @cancel="handleCancel"
        :maskClosable="false"
      >
        <input
          type="text"
          maxlength="10"
          v-model="censorId"
          class="TGA_INPUT"
          style="width: 200px; height: 30px"
        />
      </a-modal>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configs from "@/utils/config.js";
import loading from "@/components/loading/loading.vue";
export default {
  components: {
    loading,
  },
  data() {
    return {
      configs: configs.serviceEmail(),
      appId: this.$route.query.appId,
      gameId: this.$route.query.gameId,
      Version: [],
      // 用户是否认证
      userState: "",
      // 用户是否提交了素材
      materialState: "",
      // 获取版本号id
      censorId: "",
      visible: false,
      gamePlatform: 0,
      playUrl: "",
      status: 0,
      loading: true,
      onlineVersion: "",
      reviewVersion: "",
      reviewStatus: "",
      reviewPlayUrl: "",
      reviewGamePlatform: 0,
      reviewType: 0,
      gameDeveloperVo: [],
    };
  },
  // watch:{
  //    "this.$store.state.userInfo"() {
  //         this.userInfo = this.$store.getters.getUserInfo; // 按照规范在这里应该去使用getters来获取数据
  //       }
  // },

  mounted() {
    this.load();
  },
  computed: {
    ...mapState("game", ["GameAppInfo"]),
  },
  methods: {
    ...mapActions("user", ["tipMessage"]),
    ...mapActions("game", [
      "getGameDeveloperInfo",
      "cancelAuditGame",
      "submitAuditGame",
      "publishGame",
    ]),

    async load() {
      var res = await this.getGameDeveloperInfo({
        $axios: this.$axios,
        gameId: this.gameId,
      });
      if (res.code == 200) {
        this.playUrl = res.data.gameDeveloperVo.playUrl;
        this.gamePlatform = res.data.gameDeveloperVo.gamePlatform;
        this.status = res.data.gameDeveloperVo.status;
        this.gameDeveloperVo = res.data.gameDeveloperVo;
        this.onlineVersion = res.data.onlineVersion;

        this.reviewVersion = res.data.reviewVersion;
        this.reviewStatus = res.data.reviewStatus;
        this.reviewPlayUrl = res.data.reviewPlayUrl;
        this.reviewGamePlatform = res.data.reviewGamePlatform;
        this.reviewType = res.data.reviewType;
        this.userState = res.data.userState === null ? 1 : res.data.userState;
        this.loading = false;
      }
    },

    //发布上线
    async Online() {
      var res = await this.publishGame({
        $axios: this.$axios,
        id: this.gameId,
      });

      if (res.code == 200) {
        // this.Version[2].version = this.Version[1].version;
        // this.Version[2].state = 1;
        // this.Version[1].state = 5;
        this.load();
        this.tipMessage({
          context: this.$t("gameinfo.game.releasesuccess"),
        });
      }
    },

    // 显示
    showModal() {
      this.visible = true;
    },
    // 关闭
    handleCancel(e) {
      this.visible = false;
      this.censorId = "";
    },

    // 提交审核
    async SubmitAudit() {
      var self = this;
      if (this.censorId == "") {
        return;
      }
      this.visible = false;
      var res = await this.submitAuditGame({
        $axios: this.$axios,
        id: this.gameId,
        version: this.censorId,
      });
      if (res.code == 200) {
        this.load();
        this.censorId = "";
        this.tipMessage({
          context: this.$t("gameinfo.game.sendsuccess"),
        });
      }
    },

    // 取消审核
    async Cancel() {
      var res = await this.cancelAuditGame({
        $axios: this.$axios,
        id: this.gameId,
      });
      if (res.code == 200) {
        this.load();
        this.tipMessage({
          context: this.$t("gameinfo.game.cancel_review"),
        });
      }
    },

    // 体验版预览
    previewAPP() {
      if (!this.playUrl) {
        this.tipMessage({
          context: this.$t("gameinfo.game.no_preview"),
        });
        return;
      }

      if (this.gamePlatform == 2) {
        window.open(this.playUrl);
      } else {
        window.open(
          configs.newPreviewUrl(this.gameId, this.gameDeveloperVo.type) +
            this.playUrl
        );
      }
    },

    // 审核预览
    ExaminePreview() {
      if (!this.reviewPlayUrl) {
        this.tipMessage({
          context: this.$t("gameinfo.game.no_preview"),
        });
        return;
      }
      if (this.reviewGamePlatform == 2) {
        window.open(this.reviewPlayUrl);
      } else {
        window.open(
          configs.newPreviewUrl(this.gameId, this.reviewType) +
            this.reviewPlayUrl
        );
      }
    },
    // 点击复制
    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message.info(this.$t("gameinfo.game.copysuccess"));
      oInput.remove();
    },
    Newdata(data) {
      var d = new Date(data);
      var year = d.getFullYear(); //年
      var month = d.getMonth() + 1; //月
      var day = d.getDate(); //日
      var hh = d.getHours(); //时
      var mm = d.getMinutes(); //分
      var ss = d.getSeconds(); //秒
      var clock = year + "-";
      if (month < 10) clock += "0";
      clock += month + "-";
      if (day < 10) clock += "0";
      clock += day + " ";
      if (hh < 10) clock += "0";
      clock += hh + ":";
      if (mm < 10) clock += "0";
      clock += mm + ":";
      if (ss < 10) clock += "0";
      clock += ss;
      return clock;
    },
  },
};
</script>

<style scoped="scoped">
.game_box {
  width: 100%;
  height: 360px;
}
.game_title {
  padding-left: 50px;
  font-size: 18px;
  color: #282828;
}
.xian {
  width: 100%;
  height: 1px;
  margin-top: 14px;
  background-color: #f3f3f3;
}
.game {
  margin-top: 31px;
  padding-left: 50px;
}
.game_chunk {
  margin-bottom: 40px;
  display: flex;
}
.game_texts {
  width: 250px;
}
.game_chunk_title {
  line-height: 14px;
  font-size: 14px;
  color: #666666;
}
.game_time {
  margin-top: 10px;
  line-height: 14px;
  font-size: 14px;
  color: #282828;
}

.game_chunk_btn_box {
  margin-left: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.game_chunk_btn {
  display: flex;
}

.game_btn_preview {
  width: 120px;
  height: 40px;
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #aaaaaa;
  color: #666666;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
}
.game_btn {
  margin-right: 20px;
  width: 120px;
  height: 40px;
  border-radius: 4px;
  background-color: #bbbbbb;
  color: #ffffff;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
}
.game_btn_active {
  background-color: #4990fa;
}
.init_text {
  margin-top: 14px;
  font-size: 12px;
  color: #999999;
}
.init_text_active {
  color: #f65651;
}
.init_text span {
  color: #4990fa;
}
.loading_box {
  height: 360px;
}
</style>



// WEBPACK FOOTER //
// src/components/games/gameinfo/game.vue